import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

/* ================================
   BUSINESS KPI STATS
================================ */

export async function getBusinessKpiStats() {
  try {
    const fd = new FormData();

    const response = await axios.post(
      `${apiBaseUrl}adminbusinessapis/kpi_stats`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;

  } catch (error) {
    console.error("getBusinessKpiStats error:", error);

    return {
      status: false,
      type: "danger",
      success: "Failed to load KPI stats"
    };
  }
}

/* ================================
   BUSINESS LIST
================================ */

export async function getBusinesses(search = "",page=0) {
  try {
    const fd = new FormData();

    fd.append("search", search);
    fd.append("page", page+"");

    const response = await axios.post(
      `${apiBaseUrl}adminbusinessapis/getList`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;

  } catch (error) {
    console.error("getBusinesses error:", error);

    return {
      status: false,
      type: "danger",
      success: "Failed to load businesses"
    };
  }
}

/* ================================
   UPDATE BUSINESS STATUS
================================ */

export async function updateBusinessStatus(user_id, status) {
  try {
    const fd = new FormData();

    fd.append("user_id", user_id);
    fd.append("status", status);

    const response = await axios.post(
      `${apiBaseUrl}adminbusinessapis/update_status`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;

  } catch (error) {
    console.error("updateBusinessStatus error:", error);

    return {
      status: false,
      type: "danger",
      success: "Status update failed"
    };
  }
}